import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { REGISTER } from "@/constants/testIds";

export default function RegisterPage() {
  const [form, setForm] = useState({ clinic_name: "", admin_name: "", email: "", password: "", passwordConfirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.passwordConfirm) {
      setError("Las contrasenas no coinciden");
      return;
    }
    setLoading(true);
    try {
      await register({
        clinic_name: form.clinic_name,
        admin_name: form.admin_name,
        email: form.email,
        password: form.password,
      });
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background font-sans px-6 py-12">
      <div className="w-full max-w-sm animate-in fade-in slide-in-from-bottom-4 duration-500">
        <h1 className="font-serif text-3xl tracking-[0.1em] text-brand mb-1 text-center">STRANI</h1>
        <p className="text-sm text-muted-foreground mb-8 text-center">Registra tu clínica</p>

        <form onSubmit={handleSubmit} className="space-y-4" data-testid="register-form">
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Nombre de la clínica</Label>
            <Input required value={form.clinic_name} onChange={set("clinic_name")} placeholder="Strani Just Because" data-testid={REGISTER.clinicNameInput} />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Tu nombre completo</Label>
            <Input required value={form.admin_name} onChange={set("admin_name")} placeholder="Dra. Valentina Strani" data-testid={REGISTER.nameInput} />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Email</Label>
            <Input type="email" required value={form.email} onChange={set("email")} placeholder="tu@clínica.com" data-testid={REGISTER.emailInput} />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Contraseña</Label>
            <Input type="password" required minLength={6} value={form.password} onChange={set("password")} placeholder="Mínimo 6 caracteres" data-testid={REGISTER.passwordInput} />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Confirmar contraseña</Label>
            <Input type="password" required value={form.passwordConfirm} onChange={set("passwordConfirm")} placeholder="Repite tu contraseña" data-testid={REGISTER.passwordConfirmInput} />
          </div>

          {error && (
            <div className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-lg px-3 py-2" data-testid="register-error-message">
              {error}
            </div>
          )}

          <Button type="submit" className="w-full bg-brand hover:bg-brand-hover text-white" disabled={loading} data-testid={REGISTER.submitButton}>
            {loading ? "Creando cuenta..." : "Crear mi clínica"}
          </Button>
        </form>

        <p className="text-sm text-muted-foreground mt-6 text-center">
          Ya tenes cuenta?{" "}
          <Link to="/login" className="text-brand hover:text-brand-hover font-medium" data-testid={REGISTER.loginLink}>
            Inicia sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
